import { useState, useEffect } from 'react';

interface GiveawayAsset {
  id: number;
  name: string;
  reward_id: string;
  status: 'claimed' | 'issuedtomarketors' | 'notclaimed';
}

interface CreateWinnerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreate: (newWinner: any) => void;
  availableAssets: GiveawayAsset[];
  defaultRewardId: string | null;
}

const CreateWinnerModal = ({ isOpen, onClose, onCreate, availableAssets, defaultRewardId }: CreateWinnerModalProps) => {
  const [newWinner, setNewWinner] = useState({
    user_id: '' as string | number,
    reward_id: '',
    marketor_id: '' as string | number,
    twitch_id: '',
    refid: '',
    status: 'winner',
  });

  useEffect(() => {
    if (defaultRewardId) {
      setNewWinner(prev => ({ ...prev, reward_id: defaultRewardId }));
    }
  }, [defaultRewardId, isOpen]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setNewWinner(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onCreate({
      ...newWinner,
      user_id: newWinner.user_id ? parseInt(newWinner.user_id as string, 10) : null,
      marketor_id: parseInt(newWinner.marketor_id as string, 10),
    });
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="gothic-modal-container">
        <h2 className="gothic-modal-title">Create New Winner</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="twitch_id" className="block gothic-text-silver mb-1">Twitch ID</label>
            <input id="twitch_id" name="twitch_id" type="text" value={newWinner.twitch_id} onChange={handleChange} className="gothic-input w-full" required />
          </div>
          <div>
            <label htmlFor="refid" className="block gothic-text-silver mb-1">Ref ID</label>
            <input id="refid" name="refid" type="text" value={newWinner.refid} onChange={handleChange} className="gothic-input w-full" required />
          </div>
          <div>
            <label htmlFor="reward_id" className="block gothic-text-silver mb-1">Assigned Reward (optional)</label>
            <select id="reward_id" name="reward_id" value={newWinner.reward_id} onChange={handleChange} className="gothic-input w-full">
              <option value="">Default ({defaultRewardId || 'Not Set'})</option>
              {availableAssets.map(asset => (
                <option key={asset.id} value={asset.reward_id}>{asset.name} ({asset.reward_id})</option>
              ))}
            </select>
          </div>
          <div>
            <label htmlFor="marketor_id" className="block gothic-text-silver mb-1">Marketor ID</label>
            <input id="marketor_id" name="marketor_id" type="number" value={newWinner.marketor_id} onChange={handleChange} className="gothic-input w-full" required />
          </div>
          <div>
            <label htmlFor="status" className="block gothic-text-silver mb-1">Status</label>
            <select id="status" name="status" value={newWinner.status} onChange={handleChange} className="gothic-input w-full" required>
              <option value="winner">Winner</option>
              <option value="pending">Pending</option>
            </select>
          </div>
           <div>
            <label htmlFor="user_id" className="block gothic-text-silver mb-1">User ID (optional)</label>
            <input id="user_id" name="user_id" type="number" value={newWinner.user_id} onChange={handleChange} className="gothic-input w-full" />
          </div>
          <div className="flex justify-end gap-4 pt-4">
            <button type="button" onClick={onClose} className="gothic-button gothic-button-secondary">Cancel</button>
            <button type="submit" className="gothic-button gothic-button-primary">Create</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateWinnerModal;
